import { Components, CssVarsTheme, Theme } from "@mui/material";

const Checkbox = () // theme: Theme
: Components<Omit<Theme, "components" | "palette"> & CssVarsTheme> => ({
  MuiCheckbox: {
    styleOverrides: {
      root: {
        borderRadius: 3,
      },
      //   checked: theme.palette.primary.main,
    },
  },
});

export default Checkbox;
